import type { MonedaFormato } from '../../../model/kartera-api-model'

export { errorMessage, formatCount } from '../../customers/common/customer-common'
export { formatAmount, parseAmount, sanitizeDecimal } from '../../../utils/numbers'

export const CURRENCIES_PATH = '/monedas'
export const NEW_CURRENCY_PATH = `${CURRENCIES_PATH}/nueva`

export const currencyPath = (id: number) => `${CURRENCIES_PATH}/${id}`

export const FORMAT_OPTIONS: Array<{ value: MonedaFormato; label: string; example: string }> = [
    { value: '###,##0.00', label: 'Punto para decimales', example: '1,234.56' },
    { value: '###.##0,00', label: 'Coma para decimales', example: '1.234,56' },
]

export const formatExample = (formato?: string | null) =>
    FORMAT_OPTIONS.find((option) => option.value === formato)?.example || formato || '—'

export interface FormMessage {
    type: 'error' | 'success'
    message: string
}

/** `state` de navegación para mostrar un aviso al volver a la lista. */
export interface CurrenciesLocationState {
    backUrl?: string
    flash?: string
}
